<form [formGroup]="surveyEditor$().activeQuestion">
  <div class="question-form__array">
    <div class="header">
      <span class="label">Labels</span>
    </div>
    <div class="question-form__nps-labels">
      <div class="editor-question-form__input">
        <span class="label">0 scale label</span>
        <mat-form-field appearance="outline">
          <input matInput formControlName="minValueText" editorAutoFocus block="nearest" autocomplete="off" />
        </mat-form-field>
      </div>
      <div class="editor-question-form__input">
        <span class="label">10 scale label</span>
        <mat-form-field appearance="outline">
          <input matInput formControlName="maxValueText" editorAutoFocus block="nearest" autocomplete="off" />
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
